import React from 'react';
import styled, { css } from 'styled-components';

import { QUERIES } from '../constants/mediaQueries';
import { FOOTER_QUICK_LINKS, SOCIAL_LINKS } from '../constants/navigationLinks';
import { getInitialData } from '../utils/dateUtils';
import Button from './Button';
import LogoSmall from './LogoSmall';

const resetList = css`
  list-style: none;
  margin: 0;
  padding: 0;
`;

const FooterStyles = styled.footer`
  padding: var(--spacing-large);

  ${QUERIES.maxMobile} {
    padding: var(--spacing-large) var(--spacing-base);
  }
`;

const FooterContainer = styled.div`
  display: grid;
  gap: var(--spacing-xlarge);
`;

const FooterTop = styled.div`
  display: grid;
  grid-template-columns: 0.25fr 1fr 0.25fr;
  align-items: center;
  justify-items: center;
  gap: var(--layout-footer-top-gap);

  ${QUERIES.maxLaptop} {
    grid-template-columns: 1fr;
  }

  ${QUERIES.maxMobile} {
    gap: var(--spacing-xlarge);
  }
`;

const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  ${QUERIES.maxLaptop} {
    order: -1;
  }

  ${QUERIES.minLaptop} {
    justify-self: start;
  }
`;

const NavLinks = styled.ul`
  ${resetList}
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: 1fr;
  align-items: start;
  justify-items: center;
  gap: var(--spacing-base);

  ${QUERIES.maxTablet} {
    grid-auto-flow: column;
    grid-template-columns: max-content;
    justify-content: center;
    justify-items: start;
  }

  ${QUERIES.maxMobile} {
    grid-auto-flow: row;
    grid-template-columns: 1fr;
    justify-items: center;
  }

  li {
    font-weight: 600;
  }
`;

const SocialLinks = styled.ul`
  ${resetList}
  display: flex;
  align-items: start;
  justify-content: center;
  gap: var(--spacing-small);

  ${QUERIES.minLaptop} {
    justify-self: end;
  }
`;

const FooterBottom = styled.div`
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  justify-content: center;
  border-top: var(--border-default);
  gap: var(--spacing-base);
  padding-top: var(--spacing-base);
  padding-bottom: var(--spacing-small);
  font-size: var(--body-small-size);

  ${QUERIES.maxTablet} {
    flex-direction: row;
    padding-bottom: 0;
  }

  ${QUERIES.maxMobile} {
    flex-direction: column-reverse;
  }

  p {
    margin: 0;
  }
`;

const Footer: React.FC = () => {
  const { currentYear } = getInitialData();

  return (
    <FooterStyles>
      <FooterContainer>
        <FooterTop>
          <LogoWrapper>
            <LogoSmall />
          </LogoWrapper>

          <nav aria-label="Footer quick links">
            <NavLinks>
              {FOOTER_QUICK_LINKS.map((link) => (
                <li key={link.label}>
                  <Button href={link.to} text={link.label} variant="link" disableMotion={true} />
                </li>
              ))}
            </NavLinks>
          </nav>

          {/* <SocialLinks>
            {SOCIAL_LINKS.map((link) => {
              if (!link.iconName) {
                return null;
              }

              return (
                <li key={link.label}>
                  <Button
                    href={link.to}
                    ariaLabel={link.label}
                    target="_blank"
                    rel="noopener noreferrer"
                    variant="link"
                    iconName={link.iconName}
                    iconColour={link.iconColour}
                    iconPosition="icon-only"
                    showExternalLinkArrowIcon={false}
                    disableMotion={true}
                    iconSize="xlarge"
                  />
                </li>
              );
            })}
          </SocialLinks> */}
        </FooterTop>

        <FooterBottom>
          <p>&copy; {currentYear} Mondmau Developments. All rights reserved.</p>
        </FooterBottom>
      </FooterContainer>
    </FooterStyles>
  );
};

export default Footer;
